/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  EmptyTreeInfo,
  GetContractTypeTreeParams
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetContractTypeTreeUrl = (params?: GetContractTypeTreeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ContractType/GetContractTypeTree?${stringifiedParams}` : `/api/ContractType/GetContractTypeTree`
}

export const getContractTypeTree = async (params?: GetContractTypeTreeParams, options?: Parameters<typeof customInstance>[1]): Promise<EmptyTreeInfo> => {

  return customInstance<EmptyTreeInfo>(getGetContractTypeTreeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetContractTypeTreeQueryKey = (params?: GetContractTypeTreeParams,) => {
    return [
    `/api/ContractType/GetContractTypeTree`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetContractTypeTreeQueryOptions = <TData = Awaited<ReturnType<typeof getContractTypeTree>>, TError = ErrorType<unknown>>(params?: GetContractTypeTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractTypeTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContractTypeTreeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContractTypeTree>>> = ({ signal }) => getContractTypeTree(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getContractTypeTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetContractTypeTreeQueryResult = NonNullable<Awaited<ReturnType<typeof getContractTypeTree>>>
export type GetContractTypeTreeQueryError = ErrorType<unknown>


export function useGetContractTypeTree<TData = Awaited<ReturnType<typeof getContractTypeTree>>, TError = ErrorType<unknown>>(
 params: undefined |  GetContractTypeTreeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractTypeTree>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContractTypeTree>>,
          TError,
          Awaited<ReturnType<typeof getContractTypeTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContractTypeTree<TData = Awaited<ReturnType<typeof getContractTypeTree>>, TError = ErrorType<unknown>>(
 params?: GetContractTypeTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractTypeTree>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContractTypeTree>>,
          TError,
          Awaited<ReturnType<typeof getContractTypeTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContractTypeTree<TData = Awaited<ReturnType<typeof getContractTypeTree>>, TError = ErrorType<unknown>>(
 params?: GetContractTypeTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractTypeTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetContractTypeTree<TData = Awaited<ReturnType<typeof getContractTypeTree>>, TError = ErrorType<unknown>>(
 params?: GetContractTypeTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractTypeTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetContractTypeTreeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetContractTypeTreeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getContractTypeTree>>, TError = ErrorType<unknown>>(params?: GetContractTypeTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContractTypeTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContractTypeTreeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContractTypeTree>>> = ({ signal }) => getContractTypeTree(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContractTypeTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetContractTypeTreeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getContractTypeTree>>>
export type GetContractTypeTreeSuspenseQueryError = ErrorType<unknown>


export function useGetContractTypeTreeSuspense<TData = Awaited<ReturnType<typeof getContractTypeTree>>, TError = ErrorType<unknown>>(
 params: undefined |  GetContractTypeTreeParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContractTypeTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContractTypeTreeSuspense<TData = Awaited<ReturnType<typeof getContractTypeTree>>, TError = ErrorType<unknown>>(
 params?: GetContractTypeTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContractTypeTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContractTypeTreeSuspense<TData = Awaited<ReturnType<typeof getContractTypeTree>>, TError = ErrorType<unknown>>(
 params?: GetContractTypeTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContractTypeTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetContractTypeTreeSuspense<TData = Awaited<ReturnType<typeof getContractTypeTree>>, TError = ErrorType<unknown>>(
 params?: GetContractTypeTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContractTypeTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetContractTypeTreeSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






